<!--到店客流里面的 添加到店记录-->
<template>
  <article>
    <group gutter="0px" class="status">
      <cell title="记录类型" value="到店记录"></cell>
      <cell title="到店时间" :value="arriveStore.arrive_at"></cell>

      <cell v-if="arriveStore.leaved_at" title="离店时间" :value="arriveStore.leaved_at"></cell>

      <datetime v-else title="离店时间" class="datetime" placeholder="请选择"
                format="YYYY-MM-DD HH:mm" year-row="{value}年" month-row="{value}月" day-row="{value}日"
                hour-row="{value}时" minute-row="{value}分" confirm-text="完成"
                cancel-text="取消" v-model="record.leaved_at" disabled></datetime>

      <selector v-if="arriveStore.is_test_drive ===null" title="是否试驾" :options="driveList"
                v-model="record.is_test_drive">
      </selector>
      <cell v-else title="是否试驾" :value="record.is_test_drive===1?'是':'否'"></cell>
    </group>
    <group title="购车意向" class="status">
      <selector title="意向级别" :options="intentionLevel" v-model="record.intention_level"></selector>
      <cell title="购车意向" primary="content" class="status-left status-cell">
        <div slot="value" class="status-cell-group">
          <cell @click.native="selModels(true,index,item.car_model_id)"
                v-for="(item,index) in record.intention_cars" :key="index"
                :title="item.car_model_name+'-'+item.inner_color_ch+'-'+item.outer_color_ch" class="car-intention"
                is-link>
          </cell>
          <cell v-if="record.intention_cars.length < 3" @click.native="selModels(true)" title="请选择+"
                class="car-intention f-color"
                is-link></cell>
        </div>
      </cell>

    </group>
    <group title="提醒设置">
      <datetime title="预约到店" class="datetime" placeholder="请选择预约到店时间"
                format="YYYY-MM-DD HH:mm" year-row="{value}年" month-row="{value}月" day-row="{value}日"
                hour-row="{value}时" minute-row="{value}分" confirm-text="完成" cancel-text="取消" :min-hour="8"
                :max-hour="19" v-model="record.next_arrive_at" :start-date="start_date" :end-date="end_date"></datetime>
      <datetime title="下次联系" class="datetime" placeholder="请选择下次致电时间" endDate="2017-12-11"
                format="YYYY-MM-DD" year-row="{value}年" month-row="{value}月" day-row="{value}日"
                hour-row="{value}时" minute-row="{value}分" confirm-text="完成"
                cancel-text="取消" v-model="record.next_contact_at"></datetime>
    </group>
    <group title="其他备注">
      <x-textarea placeholder="请记录你的跟进情况，不少于3个且不超过60个文字" :show-counter="false" :max="60" class="sale-record-text"
                  ref=autosize                                       v-model="record.remark">
      </x-textarea>
    </group>
    <section class="btn-bottom">
      <div class="btn-fix">
        <a class="btn" href="javascript:void(0);" @click.stop="toSave()">确认提交</a>
      </div>
    </section>
  </article>
</template>

<script>
import {
  XTextarea,
  Selector,
  Datetime,
  Cell,
  Group
} from '@lx-frontend/cvux'
import cache from '../../../common/cache'

export default {
  components: {
    XTextarea,
    Selector,
    Datetime,
    Cell,
    Group
  },
  data () {
    return {
      id: '',
      localArchivesDataKey: 'customerArriveLocalData',
      sessionKey: 'customerArrive',
      originUrl: 'originUrl',
      arriveStore: null,
      start_date: null,
      end_date: null,
      car_color: [],
      intentionLevel: [],
      driveList: [
        {
          'key': '1',
          'value': '是'
        },
        {
          'key': '0',
          'value': '否'
        }
      ],
      customerInfo: null,
      record: {
        'customer_id': '',
        'intention_cars': [],
        'intention_level': '2',
        'is_test_drive': '1',
        'leaved_at': '',
        'next_arrive_at': '',
        'next_contact_at': '',
        'remark': '',
        'store_visit_id': ''
      }
    }
  },
  created () {
    let id = this.id = this.$route.params.id
    // 之前页面缓存的数据
    this.arriveStore = cache.getSessionData(this.sessionKey + '_' + id)
    this.start_date = this.futureTime(1)
    this.end_date = this.futureTime(180)
    // 枚举列表
    this.enums()
    // 是否缓存数据.
    let localData = cache.getSessionData(this.localArchivesDataKey)
    if (localData && localData.record) {
      this.record = localData.record
    } else {
      this.record.customer_id = this.arriveStore.relate_customer_id
      this.record.store_visit_id = this.arriveStore.id
      this.record.is_test_drive = this.arriveStore.is_test_drive
      this.record.leaved_at = this.arriveStore.leaved_at ? this.arriveStore.leaved_at : ''
      // 客户详情
      this.getCustomerInfo()
    }
    // 是否编辑页面购车意向
    let query = this.$route.query
    let modelId = query.modelId
    if (modelId) {
      this.$rest.saleManage.getAppointedCarInfo(null, modelId).then((res) => {
        if (res.code === 0) {
          let outer = query.outer
          let inner = query.inner
          let obj = {
            car_model_id: parseInt(modelId),
            outer_color: parseInt(outer),
            inner_color: parseInt(inner),
            car_model_name: res.data.model_name
          }
          let innerColorCh = this.car_color.find(t => {
            return inner === t.key
          })
          if (innerColorCh) {
            obj.inner_color_ch = innerColorCh.value
          }
          let outerColorCh = this.car_color.find(t => {
            return outer === t.key
          }).value
          if (outerColorCh) {
            obj.outer_color_ch = outerColorCh.value
          }
          // 更改/替换
          if (localData.chooseItem) {
            let index = localData.chooseItem.index
            Object.assign(this.record.intention_cars[index], obj)
          } else {
            // 添加
            let intentionCarsEX = this.record.intention_cars.findIndex(x => {
              return x.car_model_id === parseInt(modelId)
            })
            if (intentionCarsEX === -1) {
              this.record.intention_cars.push(obj)
            }
          }
        }
      })
    }
  },
  methods: {
    enums () {
      this.$rest.saleManage.getEnums().then(res => {
        if (res.code === 0) {
          this.intentionLevel = res.data.intention_level
          this.car_color = res.data.car_color
        }
      })
    },
    getCustomerInfo () {
      this.$rest.saleManage.arrivedCustomerInfo(null, this.record.customer_id).then(res => {
        if (res.code === 0) {
          this.customerInfo = res.data
          // 意向车型
          if (this.customerInfo.intention_cars.length) {
            this.record.intention_cars = this.customerInfo.intention_cars.map(v => {
              v.inner_color_ch = this.car_color.find(t => {
                return v.inner_color === parseInt(t.key)
              }).value
              v.outer_color_ch = this.car_color.find(t => {
                return v.outer_color === parseInt(t.key)
              }).value
              return v
            })
          }
          // 预约到店,下次联系
          this.record.next_arrive_at = this.customerInfo.next_arrive_at || ''
          this.record.leaved_at = this.customerInfo.leaved_at || ''
          this.record.next_contact_at = this.customerInfo.next_contact_at || ''
          this.record.intention_level = this.customerInfo.intention_level ? this.customerInfo.intention_level + '' : '5'
        }
      })
    },
    selModels (flag, index, editId) {
      // 当前路径
      cache.setSessionData(this.originUrl, {
        from: 'customerArriveRecord',
        path: '/salemanage/staff/customerarriverecord/' + this.id,
        includeColor: flag
      })
      // 当前页面数据
      let chooseItem = null
      if (typeof index !== 'undefined' && typeof editId !== 'undefined') {
        chooseItem = { index: index, editId: editId }
      }
      cache.setSessionData(this.localArchivesDataKey, { record: this.record, chooseItem: chooseItem })
      if (flag) {
        this.$router.push('/salemanage/car/intendbrands')
      } else {
        this.$router.push('/salemanage/car/brands')
      }
    },
    futureTime (days) {
      let millSeconds = Math.abs(new Date().getTime() + (days * 24 * 60 * 60 * 1000))
      let future = new Date(millSeconds)
      let year = future.getFullYear()
      let month = future.getMonth() + 1
      if (month < 10) month = '0' + month
      let date = future.getDate()
      if (date < 10) date = '0' + date
      return (year + '-' + month + '-' + date)
    },
    toSave () {
      let record = this.record
      let remark = record.remark
      if (remark === '' || remark.length < 3 || remark.length > 60) {
        this.showToast('备注信息必须为3~60个文字之间')
        return false
      }
      let transport = {
        customer_id: parseInt(record.customer_id),
        intention_cars: record.intention_cars,
        intention_level: parseInt(record.intention_level),
        is_test_drive: parseInt(record.is_test_drive),
        leaved_at: record.leaved_at,
        next_arrive_at: record.leaved_at,
        next_contact_at: record.next_contact_at || null,
        remark: record.remark,
        store_visit_id: record.store_visit_id
      }
      if (record.leaved_at === '' || record.leaved_at === null) {
        transport.leaved_at = null
      } else if (record.leaved_at) {
        let date = new Date(record.leaved_at)
        if (date.getSeconds() > 0 || record.leaved_at.endsWith('00')) {
          transport.leaved_at = record.leaved_at
        } else {
          transport.leaved_at = record.leaved_at + ':00'
        }
      }
      if (record.next_arrive_at === '' || record.next_arrive_at === null) {
        transport.next_arrive_at = null
      } else if (record.next_arrive_at) {
        let date = new Date(record.next_arrive_at)
        if (date.getSeconds() > 0 || record.next_arrive_at.endsWith('00')) {
          transport.next_arrive_at = record.next_arrive_at
        } else {
          transport.next_arrive_at = record.next_arrive_at + ':00'
        }
      }
      this.$rest.saleManage.customerArriveNote(transport).then(res => {
        if (res.code === 0) {
          this.showToast('提交成功')
        } else {
          this.showToast(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
